import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as Actions from './actions'
import { IPlaato2 } from 'app/models/plaato2';

export interface State extends EntityState<IPlaato2> {
  // additional entity state properties
  selectedId: string | null;
  isOffline: boolean;
  triggeredOffline: boolean;
  displaySetupButton: boolean;
  displaySubmitForm: boolean;

  setupIsLoading: boolean;

  error: string;
}


export function sortByName(a: IPlaato2, b: IPlaato2): number {
  return a.name.localeCompare(b.name);
}
export function selectId(a: IPlaato2): string {
  return a.id ?? '';
}
export const adapter: EntityAdapter<IPlaato2> = createEntityAdapter<IPlaato2>({
  sortComparer: sortByName,
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  isOffline: false,
  displaySetupButton: true,
  displaySubmitForm: false,
  setupIsLoading: false,
  error: '',
  triggeredOffline: false
});

export const stateName = 'plaato2';

export const reducer = createReducer<State>(
  initialState,
  on(Actions.clearAllItems, (state) => {
    return adapter.removeAll(state);
  }),

  on(Actions.loadItemsSuccess, (state, { items }) => {
    return adapter.setAll(items, state);
  }),

  on(Actions.loadItemsFailure, (state, { error }) => {
    return { ...state, error: error };
  }),


  on(Actions.setItem, (state, action) => {
    return Object.assign({ ...state, selectedId: action.id });
  }),

  on(Actions.setTriggerOffline, (state, action) => {
    return Object.assign({ ...state, triggeredOffline: action.triggered });
  }),

  on(Actions.setDisplaySetupButton, (state, action) => {
    return Object.assign({ ...state, displaySetupButton: action.display });
  }),

  on(Actions.setDisplaySubmitForm, (state, action) => {
    return Object.assign({ ...state, displaySubmitForm: action.display });
  }),

  on(Actions.setIsOffline, (state, action) => {
    return Object.assign({ ...state, isOffline: action.isOffline });
  }),

  on(Actions.setSetupIsLoading, (state, action) => {
    return Object.assign({ ...state, setupIsLoading: action.setupIsLoading });
  }),

  on(Actions.setError, (state, action) => {
    return Object.assign({ ...state, error: action.error });
  }),




);

// get the selectors
const { selectAll, selectEntities } = adapter.getSelectors();

// Export selectAll for effect caching
export { selectAll };

const selectState = createFeatureSelector<State>(stateName);
export const getSelectedId = (state: State) => state.selectedId;
export const getDisplaySetupButton = (state: State) => state.displaySetupButton;
export const getDisplaySubmitForm = (state: State) => state.displaySubmitForm;
export const getSetupIsLoading = (state: State) => state.setupIsLoading;
export const getError = (state: State) => state.error;

export const getIsOffline = (state: State) => state.isOffline;
export const getIsTriggered = (state: State) => state.triggeredOffline;
export const getState = createFeatureSelector<State>(stateName);
export const selectAllItems = createSelector(getState, selectAll);
export const selectAllEntities = createSelector(getState, selectEntities);
export const getCurrentId = createSelector(getState, getSelectedId);

export const selectIsOffline = createSelector(getState, getIsOffline);
export const selectIsTriggered = createSelector(getState, getIsTriggered);
export const selectDisplaySetupButton = createSelector(getState, getDisplaySetupButton);
export const selectDisplaySubmitForm = createSelector(getState, getDisplaySubmitForm);
export const selectSetupIsLoading = createSelector(getState, getSetupIsLoading);
export const selectError = createSelector(getState, getError);

export const selectCurrentItem = createSelector(selectAllEntities, getCurrentId, (entities, id) => {
  if (id) return entities[id];
  return null;
});
export const selectEntity = (id: string) => createSelector(selectAllEntities, entities => entities[id]);


export const selectIsOnlineAndTriggered = createSelector(
  selectIsOffline, selectIsTriggered, (offline, triggered) => {
    return (!offline && triggered);
  });
